import React from 'react';

import { Media } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').TestimonialsBlock}
 */

const Testimonials = ({
    title,
    testimonials
}) => {
    const bgColor = 'bg-surface-panel-white';
    return (
        <section className={`${bgColor} py-32 col-padding rounded-lg flex-grow`}>
            <h2 className='type-style-sans-h1 w-full sm:w-8/12 md:w-7/12'>
                {title}
            </h2>
            <div className='mt-24 md:mt-32 mb-8 md:mb-16 sm:grid-cols-3 gap-y-24 sm:gap-8 md:gap-16 grid'>
                {testimonials.map((testimonial) => {
                    return (
                        <div
                            className='flex flex-col'
                            key={testimonial.id}>
                            <Media {
                                ...{
                                    ...testimonial.media,
                                    ...(testimonial.media.videoEmbed ? {
                                        videoEmbed: {
                                            ...testimonial.media.videoEmbed,
                                            poster: testimonial.media?.videoEmbed?.poster || testimonial.media?.videoEmbed?.embed?.thumbnailUrl
                                        }
                                    } : {} )
                                }
                            }/>
                            <p className='type-style-serif-h4 mt-16'>
                                {testimonial.quote}
                            </p>
                            <p className='type-style-sans-body-med mt-16'>
                                {testimonial.name}
                            </p>
                            <p className='type-style-sans-body'>
                                {testimonial.role}
                            </p>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Testimonials;
